import { useNavigation } from '@redbubble/next-provider';

import { ReactElement, ReactNode } from 'react';

interface LoadingBoundaryProps {
  children: ReactNode;
  loadingComponent: ReactElement;
}

export const LoadingBoundary: React.FC<LoadingBoundaryProps> = ({
  children,
  loadingComponent,
}) => {
  const { loading } = useNavigation();
  if (!children) return null;
  if (loading) {
    return loadingComponent;
  }
  return <>{children}</>;
};
